import { ReportFacade } from '@mode/reports/domain';
import * as angular from 'angular';
import { Resource } from '@mode/shared/util-halogen';
import { ReportDataService } from '~/services/report-data-service';

import RenameReportModalController from './rename-report-modal-controller';
import template from './rename-report-modal.html';

const updateLegacyReport = (
  newName,
  newDescription,
  reportFacade: ReportFacade,
  reportDataService: ReportDataService
) => {
  const subRef = reportFacade.headerReportData$.subscribe((report) => {
    const reportDescription = report.description || '';
    if (report.name === newName && reportDescription === newDescription) {
      reportDataService.updateReportSettingsSilently(new Resource(report));
      subRef.unsubscribe();
    }
  });
};

const renameReportModalDirective = function (Modal, reportDataService: ReportDataService, reportFacade: ReportFacade) {
  return {
    restrict: 'A',
    scope: {
      report: '<',
      isDataset: '<?',
      isReportState: '<?',
      isDatasetPublished: '<?',
    },
    link: function ($scope: angular.IScope, elem, attrs) {
      elem.on('click.renameReportModal', (event) => {
        const modal = Modal.open(
          {
            name: $scope.report.name,
            description: $scope.report.description,
            isDataset: $scope.isDataset,
            isDatasetPublished: $scope.isDatasetPublished,
          },
          {
            template: template,
            controller: RenameReportModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            animation: true,
            backdrop: 'static',
          }
        );
        modal.result.then((r) => {
          if ($scope.isReportState) {
            // Updating legacy store with new name AFTER new store has the updated values.
            // some functions pull the old store data, but will be out of sync with latest changes
            updateLegacyReport(r.name, r.description, reportFacade, reportDataService);
            reportFacade.editorDialogRenameReport($scope.report.token, r.name, r.description);
          } else {
            reportDataService.renameReport($scope.report.token, r.name, r.description);
          }
        });
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.renameReportModal'));
    },
  };
};

renameReportModalDirective.$inject = ['ModalService', 'ReportDataService', 'ReportFacade'];

angular.module('mode.components').directive('renameReport', renameReportModalDirective);
